import { Fragment, useEffect, useRef, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { useDispatch } from 'react-redux'
import { resetRecentlyAddedCartProductId } from '../../features/cart/redux/cartSlice'
import { Link, useLocation } from 'react-router-dom'
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalBody,
  MDBModalFooter,
} from 'mdb-react-ui-kit'
import classes from './Homepage.module.css'
import HomepageNavigation from '../../components/HomepageNavigation'
import FavoritesProducts from '../../components/homepage/FavoriteProducts'
import WhatIsPays from '../../components/homepage/WhatIsPays'
import AboutPays from '../../components/homepage/AboutPays'
import HowPaysWorks from '../../components/homepage/HowPaysWorks'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faTreeChristmas,
  faStarChristmas,
  faGift,
} from '@fortawesome/pro-light-svg-icons'

import heroMobile from '../../assets/img/heroSM.png'
import heroDesktop from '../../assets/img/hero.png'
import heroDesktopXL from '../../assets/img/heroXL.png'
import heroIcons from '../../assets/img/hero-icons.svg'
import check from '../../assets/img/checkGreen.svg'

import MoreFavoriteProducts from '../../components/homepage/MoreFavoriteProducts'
import FAQ from '../../components/homepage/FAQ'

function HomepageMain(props) {
  const [basicModal, setBasicModal] = useState(false)
  const toggleOpen = () => setBasicModal(!basicModal)

  const dispatch = useDispatch()

  const howItWorksSection = useRef()

  const location = useLocation()

  useEffect(() => {
    dispatch(resetRecentlyAddedCartProductId())
  }, [dispatch])

  useEffect(() => {
    const today = new Date()
    const isChristmasEve =
      today.getDate() === 24 &&
      today.getMonth() === 11 &&
      today.getFullYear() === 2024
    const isNewYearsEve =
      today.getDate() === 31 &&
      today.getMonth() === 11 &&
      today.getFullYear() === 2024

    if (isChristmasEve || isNewYearsEve) {
      // Simulate opening the modal after the homepage is loaded
      setTimeout(() => {
        setBasicModal(true)
      }, 1000)
    }
  }, [])

  useEffect(() => {
    if (location.hash === '#soFunktioniert') {
      setTimeout(() => {
        window.scrollTo({
          top: howItWorksSection.current.offsetTop,
          behavior: 'smooth',
        })
      }, 100)
    }
  })

  return (
    <Fragment>
      <Helmet>
        <title>PAYS - digitale Gutscheine auf Rechnung</title>
        <meta
          name='description'
          content='Erhalte schnell und einfach digitale Gutscheine auf
          Rechnung'
        />
      </Helmet>
      <MDBModal
        open={basicModal}
        onClose={() => setBasicModal(false)}
        tabIndex='-1'
      >
        <MDBModalDialog centered>
          <MDBModalContent className={classes.christmasModal}>
            <MDBModalHeader className={classes.christmasModalHeader}>
              <FontAwesomeIcon
                icon={faStarChristmas}
                fontSize='28px'
                className='color-success'
              />
              <FontAwesomeIcon
                icon={faTreeChristmas}
                fontSize='28px'
                className='color-success mx-3'
              />
              <FontAwesomeIcon
                icon={faGift}
                fontSize='28px'
                className='color-success'
              />
              <MDBBtn
                className='btn-close btn-close-green color-success'
                color='none'
                onClick={toggleOpen}
              ></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody className={classes.christmasModalBody}>
              <p className='fw-bold'>
                Wir von Pays wünschen Ihnen eine schöne Weihnachtszeit und einen
                guten Rutsch ins neue Jahr 2025
              </p>
              Am 24.12.2024 und 31.12.2024 ist der Support für Sie von 8.00 -
              12.00 Uhr erreichbar.
              <br />
              Bitte beachten Sie, dass es über die Feiertage zu einer längeren
              Bearbeitungszeit der Anfragen kommen kann.  <br />
              Ihr Pays Team &#127876; &#127876; &#127876;
            </MDBModalBody>

            <MDBModalFooter className={classes.christmasModalFooter}>
              <MDBBtn color='secondary' onClick={toggleOpen}>
                Schließen
              </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>

      <section className={`${classes.heroMain}`}>
        <HomepageNavigation />

        <div className={`row ${classes.heroRow}`}>
          <div
            className={`${classes.heroMainText} col-lg-6 px-3 px-lg-0 py-lg-5`}
          >
            <div className={`${classes.heroContent} mx-auto my-auto`}>
              <h1 className='mb-4 mb-xl-5 fw-light'>
                Erhalte innerhalb einer Minute <br />
                <span className={`${classes.heroBold} text-uppercase`}>
                  digitale Gutscheincodes
                </span>
              </h1>
              <div className='d-flex h-100 align-items-center mb-3 mb-xxl-4'>
                <img
                  src={check}
                  alt='check'
                  className={`${classes.check} me-2`}
                />
                <p className='my-auto'>Sofort online verfügbar</p>
              </div>
              <div className='d-flex h-100 align-items-center mb-3 mb-xxl-4'>
                <img
                  src={check}
                  alt='check'
                  className={`${classes.check} me-2`}
                />
                <p className='my-auto'>Bequem auf Rechnung kaufen  </p>
              </div>
              <div className='d-flex h-100 align-items-center mb-3 mb-xxl-4'>
                <img
                  src={check}
                  alt='check'
                  className={`${classes.check} me-2`}
                />
                <p className='my-auto'>Gutscheincodes 24/7 erhaltbar</p>
              </div>
              <Link to='/alle-produkte' className={`${classes.fitContent} `}>
                <MDBBtn className={` btn-pays mx-auto mx-md-0 my-4`}>
                  Jetzt kaufen
                </MDBBtn>
              </Link>
            </div>
          </div>
          <div
            className={`${classes.imgBox} col-lg-6 text-lg-end pb-2 position-relative  py-lg-5 px-0`}
          >
            <picture>
              <source media='(min-width:1920px)' srcSet={heroDesktopXL} />
              <source media='(min-width:575px)' srcSet={heroDesktop} />
              <img
                src={heroDesktop}
                alt='Hero'
                className={`img-fluid ${classes.heroImg}`}
              />
            </picture>
          <img src={heroIcons} alt='icons' className={`${classes.heroIcons} position-absolute`}/>
          </div>
        </div>

        <div className={`${classes.favoriteProducts} w-100 text-center`}>
          <h2 className='mx-auto fw-normal'>Unsere Bestsellers</h2>
          <div className={`${classes.carouselContainer} mx-auto`}>
            <FavoritesProducts />
          </div>

          <Link to='/alle-produkte' className={`mx-auto`}>
            <MDBBtn
              className={`btn btn-pays-outline text-uppercase mx-auto my-4 my-md-5`}
            >
              Alle Gutscheine
            </MDBBtn>
          </Link>
        </div>
      </section>

      <section className={`bg-pays-green`}>
        <WhatIsPays />
      </section>
      <section className='bg-white'>
        <AboutPays />
      </section>

      <section className={`${classes.bestProducts} bg-gray`}>
        <div className={`${classes.favoriteProducts} w-100 text-center`}>
          <h2 className='mx-auto fw-normal'>Beliebte Produkte</h2>
          <div className={`${classes.carouselContainer}`}>
            <FavoritesProducts />
          </div>

          <Link to='/alle-produkte' className={`mx-auto`}>
            <MDBBtn
              className={`btn btn-pays-outline text-uppercase mx-auto my-4 my-md-5`}
            >
              Alle Gutscheine
            </MDBBtn>
          </Link>
        </div>
      </section>

      <section
        className={` bg-white`}
        id='soFunktioniert'
        ref={howItWorksSection}
      >
        <HowPaysWorks />
      </section>

      <section className={`${classes.bestProducts} bg-pays-green`}>
        <div className={`${classes.favoriteProducts} w-100 text-center`}>
          <h2 className='mx-auto fw-normal'>Weitere Beliebte Produkte</h2>
          <div className={`${classes.carouselContainer}`}>
            <MoreFavoriteProducts />
          </div>

          <Link to='/alle-produkte' className={`mx-auto`}>
            <MDBBtn
              className={`btn btn-pays-dark text-uppercase mx-auto my-4 my-md-5`}
            >
              Alle Gutscheine
            </MDBBtn>
          </Link>
        </div>
      </section>

      <FAQ />
    </Fragment>
  )
}

export default HomepageMain
